import Colors from "../../../../../theme/colors";

export default {
  container: {
    borderRadius: "12px",
    boxShadow: "6px 6px 10px #0000001A",
    margin: "10px 20px 70px 10px",
    minHeight: "570px",
    background: "#FFFFFF",
  },
  topContainer: {
    padding: "2rem",
  },
  inforTitle: {
    color: "#8C8C8C",
    fontSize: "18px",
    paddingTop: "20px",
    paddingBottom: "10px",
  },
  flexContainer: {
    display: "flex",
  },
  buttonStyles: {
    backgroundColor: Colors.midnightBlue,
    borderRadius: "8px",
    width: 178,
    height: 40,
    // padding: "12px 28px",
    marginTop: "100px",
    marginBottom: "20px",
    minWidth: "140px",
  },

  cancelBtnStyles: {
    borderRadius: "8px",
    padding: "12px 28px",
    width: 176,
    height: 40,
    marginTop: "100px",
    marginBottom: "20px",
    marginLeft: "32px",
    color: "#043D90",
    minWidth: "140px",
  },
  customTextFieldSecondary: {
    width: "47%",
    marginBottom: "18px",
    marginRight: "3%",
    marginTop: "12px",
    // padding:"16px 30px 16px"
  },
  paddinContainerLeftRight: {
    paddingleft: "32.5px",
    paddingRigth: "32.5px",
  },
  inputStyleCss: {
    width: "100%",
    padding: "12px 20px",
    marginBottom: "19px",
    boxSizing: "border-box",
    color: "#A4A4A4",
    "&:hover": {
      background: "#efefef",
      color: "green",
    },
    "&:focus": {
      background: "#efefef",
    },
  },
  TextInputCss: {
    borderRadius: "4px",
    border: "1px solid #A4A4A4",
    padding: "10px 20px",
    fontSize: "14px",
  },
  inputStyles: {
    fontWeight: "200",
    color: "#A4A4A4",
  },
  formRow: {
    display: "flex",
    marginBottom: "1.5rem",
    flex: 1,
    gap: 15,
  },
  item: {
    flex: "1 1 5%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  colName: {
    position: "relative",
  },
  longItem: {
    display: "flex",
    flex: "1 1 41%",
  },
  mediumItem: {
    flex: "1 1 18%",
  },
  smallItem: {
    flex: "1 1 18%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  addLink: {
    color: "#183053",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
  },
  defaultAddress: {
    color: "#183053",
    fontSize: "15px",
    fontWeight: "500",
    textDecoration: "underline",
  },
};
